<template>
  <div class="draggable-menu-slot slot-component">
    <service-orders
      v-if="slotType === 'service_orders'"
      :key="`${slotId}-${data.view || 'all'}`"
      embedded
      :slot-id="slotId"
      :view="data.view || null"
    />
    <dmp-alarms-table v-if="slotType === 'dmp_alarms'" :show-filters="false" />

    <dmp-logs-table
      v-if="slotType === 'dmp_logs'"
      :show-filters="false"
      embedded
      :slot-id="slotId || 'default'"
      :slot-filters="slotFilters"
    />

    <dmp-panels-table v-if="slotType === 'dmp_panels'" :show-filters="false" />

    <dmp-profiles-table
      v-if="slotType === 'dmp_profiles'"
      :show-filters="false"
    />

    <unit-table
      v-if="slotType === 'unit'"
      :show-filters="false"
      :filters="slotFilters"
    />

    <operational-security-evaluations
      v-if="slotType === 'operational_processes'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
      :auto-create="autoCreate"
    />

    <Face
      v-if="slotType === 'omnicloud_face_recognition'"
      :show-filters="false"
      embedded
      :slot-id="slotId || 'default'"
      :slot-filters="slotFilters"
    />

    <List
      v-if="slotType === 'omnicloud_watchlist'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
    />

    <Alarm
      v-if="slotType === 'alarm'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
      :slot-filters="slotFilters"
    />

    <DetectionEvent
      v-if="slotType === 'detection_event'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
      :filters="slotFilters"
    />

    <dmp-devices
      v-else-if="shouldShowDmp && panelId"
      :panel-id="panelId"
      source="grid"
      :key="`dmp-${panelId}`"
    />

    <CrisisForm
      v-if="slotType === 'crisis_form'"
      :show-filters="false"
      :isFromSlot="true"
      :slot-id="slotId || 'default'"
    />

    <ExternalPersonnelAccessControl
      v-if="slotType === 'external_personnel_access_control'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
      :is-from-slot="true"
      :filters="slotFilters"
    />

    <Teams
      v-if="slotType === 'teams'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
    />

    <Directory
      v-if="slotType === 'directory'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
    />

    <PatrolLog
      v-if="slotType === 'patrol_logs'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
    />

    <UnitLog
      v-if="slotType === 'unit_log'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
    />

    <UnitCommander
      v-if="slotType === 'unit_commanders'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
    />

    <UserShifts
      v-if="slotType === 'user-shifts'"
      :show-filters="false"
      :slot-id="slotId || 'default'"
    />

    <HanwhaLogs
      v-if="slotType === 'hanwha_logs'"
      embedded
      :show-filters="false"
      :slot-id="slotId || 'default'"
      :slot-filters="slotFilters"
    />

  </div>
</template>

<script>
import UnitTable from "@/views/unit/Index.vue";
import DmpAlarmsTable from "@/views/dmp/dmp_alarms/Index.vue";
import DmpLogsTable from "@/views/dmp/dmp_logs/Index.vue";
import DmpPanelsTable from "@/views/dmp/dmp_panels/Index.vue";
import DmpProfilesTable from "@/views/dmp/dmp_profiles/Index.vue";
import OperationalSecurityEvaluations from "@/views/operational_security/evaluations/Index.vue";
import Face from "@/views/omnicloud_fr/Face/Index.vue";
import List from "@/views/omnicloud_fr/WatchList/Index.vue";
import Alarm from "@/views/alarm/Index.vue";
import DetectionEvent from "@/views/detection_event/Index.vue";
import DmpDevices from "@/views/dmp/dmp_panels/Devices.vue";
import CrisisForm from "@/views/operational_security/crisis_form/Index.vue";
import { computed, ref, watch } from "@vue/composition-api";
import ExternalPersonnelAccessControl from "@/views/operational_security/operational_processes/Index.vue";
import Teams from "@/views/teams/Index.vue";
import Directory from "@/views/directory/Index.vue";
import axios from "@axios";
import PatrolLog from "@/views/patrol_logs/patrol_log/Index.vue";
import UnitLog from "@/views/patrol_logs/unit_log/Index.vue";
import UnitCommander from "@/views/patrol_logs/unit_commander/Index.vue";
import UserShifts from "@/views/user_shifts/Index.vue";
import HanwhaLogs from "@/views/hanwha/log/Index.vue";
import ServiceOrders from "@/views/service_orders/Index.vue";

// An alarm view saves its slot as {filters, source}; AlarmViewService rewrites
// it as {filters, type}. Mapping source lets the slot mount either way.
const SOURCE_TYPES = {
  dmp_logs: "dmp_logs",
  omnicloud_fr: "omnicloud_face_recognition",
  alarm: "alarm",
  panel: "panel",
  hanwha_logs: "hanwha_logs",
};

export default {
  props: {
    data: {
      type: Object,
    },
    slotId: {
      type: String,
      required: false,
    },
  },
  components: {
    ServiceOrders,
    OperationalSecurityEvaluations,
    DmpAlarmsTable,
    DmpLogsTable,
    DmpPanelsTable,
    DmpProfilesTable,
    DmpDevices,
    UnitTable,
    Face,
    List,
    Alarm,
    DetectionEvent,
    CrisisForm,
    ExternalPersonnelAccessControl,
    Teams,
    Directory,
    PatrolLog,
    UnitLog,
    UnitCommander,
    UserShifts,
    HanwhaLogs
  },
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const panelId = ref(null);

    console.log(props.data)

    const slotType = computed(
      () => props.data?.type || SOURCE_TYPES[props.data?.source] || null
    );

    // Unwraps the extra nesting AlarmViewService adds.
    const slotFilters = computed(() => {
      const filters = props.data?.filters;
      if (!filters) return null;
      return filters.filters ?? filters;
    });

    const autoCreate = computed(() => !!props.data?.autoCreate);

    const shouldShowDmp = computed(() => slotType.value === "panel");

    const fetchPanelFromAlarm = async () => {

      if (!shouldShowDmp.value || !props.data?.alarm?.id) {
        panelId.value = null;
        error.value = null;
        return;
      }

      isLoading.value = true;
      error.value = null;

      try {
        const params = { id_alarm: props.data.alarm.id, q: "" };
        const response = await axios.get("v1/dmp/alarms", { params });
        // console.log('response panel',{response})
        const responseData = response.data.data[0]; //TODO: add validation
        panelId.value = responseData?.id_dmp_panel;
        // console.log('PanelId', {panelId})
      } catch (e) {
        panelId.value = null;
        error.value =
          e?.response?.data?.message || e?.message || "Error al cargar panel DMP";
      } finally {
        isLoading.value = false;
      }
    };

    watch(
      () => [slotType.value, props.data?.id],
      () => {
        fetchPanelFromAlarm();
      },
      { immediate: true }
    );

    return {
      isLoading,
      error,
      panelId,
      shouldShowDmp,
      slotType,
      slotFilters,
      autoCreate,
    };
  },
};
</script>
